// extracted by mini-css-extract-plugin
export default {"videoDescription":"youtube-view_videoDescription__yhDS5","editable":"youtube-view_editable__JL5TZ"};